// Esempio JS vanilla ispirato a page-product

import axios from 'axios'; // se stai usando webpack/ESM come negli altri bundle
import { CART as ENDPOINT} from '../common/endpoints'
import { error, success, warning } from '../main/toast-notifications'
import { t } from '../main/i18n'
import { updateMiniCart } from '../main/cart'
const RECAPTCHA_KEY = '6Ldtk0gfAAAAACPWMoSiKjmoEZ68JbjcdCT9Vqo-'; // stessa key usata in page-product

// Se hai già window.motostorm configurato globalmente su tutte le pagine:
const ms = window.motostorm || {}
const lang = ms.lang || 'it'
const country = ms.country || 'ITA'
const currency = ms.currency || 'EUR'

function initGiftCardAddToCart() {
  const buttons = document.querySelectorAll('.j-giftcard-add-to-cart')
  if (!buttons.length) return

  buttons.forEach(btn => {
    btn.addEventListener('click', event => {
      event.preventDefault()

      const encryptedAmount = btn.getAttribute('data-gift-amount')
      if (!encryptedAmount) return

      // quantità e size fisse per i buoni
      const qty = '1'
      const size = 'UNICA'

      grecaptcha.ready(() => {
        grecaptcha.execute(RECAPTCHA_KEY, { action: 'submit' }).then(token => {
          addGiftToCart({
            qty,
            size,
            encryptedAmount,
            token
          })
        })
      })
    })
  })
}

async function addGiftToCart({ qty, size, encryptedAmount, token }) {
  const payload = {
    data: {
      token,
      qty,
      size,
      lang,
      country,
      currency,
      product: {
        productId: 1,          // deve corrispondere a quello che gestisci lato PHP
        productCode: 'GIFT',
        productBrand: 'MOTOSTORM',
        productPrice: encryptedAmount,
        productStock: 1,
        productSpecialOffer: 0
      }
      // niente asyncCarousels su questa pagina
    }
  };

  try {
    const res = await axios.post(ENDPOINT, payload)
    // aggiorno la mini-cart come fa page-product/cart_service handler
    const cartToolbar = document.querySelector('.c-navbar__toolbar-item--cart')
    if (cartToolbar && res.data && res.data.cart) {
      cartToolbar.innerHTML = res.data.cart
      // riaggancio gli handler di rimozione dal carrello se servono
      // (lo fa una funzione simile a quella nel modulo che gestisce .j-cart-remove)
    }

    // mostra toast di successo: riusa la tua utility notifiche se disponibile
	success(t('add-to-cart-success'))
  } catch (err) {
    console.error('Errore aggiunta buono regalo', err)
    // showToastError(i18n('add-to-cart-error'))
  }
}

// Inizializzazione
initGiftCardAddToCart()